
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getIsknDateTitle } from '../../reducers/iskn';

import Text from '../../common/client/components/Text';
import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({

    IsknDataSetKatuzeInfo: {
        backgroundColor: '#eeeeee',
        margin: 4
    },
    resultTitle: {
        backgroundColor: '#bbbbbb',
        padding: 4,
        /*
        '&:hover': {
            backgroundColor: '#0078d4',
            color: '#ffffff',
            cursor: 'pointer'
        }
        */
    },
    resultContent: {
        backgroundColor: '#eeeeee',
        padding: 4
    },
    KatuzeInfo: {
        paddingBottom: 8
    },
    sourceInfo: {
        paddingLeft: 24,
        paddingRight: 8
    }
});

const KatuzeInfo = ({katuzeItem, katuzeInfo}) => {

    // eslint-disable-next-line eqeqeq
    let infoForKatuze = katuzeInfo.filter(item => (item.katuze_kod == katuzeItem.kod));

    return (
        <Stack className={classNames.KatuzeInfo}>
            <Stack.Item>
                <Text>KÚ: </Text>
                <Text bold>{katuzeItem.nazev}</Text>
            </Stack.Item>
            <Stack.Item>
                <Stack className={classNames.sourceInfo}>
                    <IfComp cond={infoForKatuze.length === 0}>
                        <Text>- žádná data</Text>
                    </IfComp>
                    {infoForKatuze.map((item, index) => {
                        return (
                            <Stack.Item key={index}>
                                <Text>- {item.description}</Text>
                            </Stack.Item>
                        );
                    })}
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

const IsknDataSetKatuzeInfo = ({
    data,
    projectKatuzeItems
}) => {

    const isknDateTitle = useSelector(state => getIsknDateTitle(state.iskn, data.isknDate));

    return (
        <Stack className={classNames.IsknDataSetKatuzeInfo}>
            <Stack horizontal className={classNames.resultTitle} tokens={{childrenGap: 8}} >
                <Stack.Item grow>
                    <Text>{isknDateTitle}</Text>
                </Stack.Item>
            </Stack>
            <Stack.Item className={classNames.resultContent}>
                {projectKatuzeItems.map(item => {
                    return (
                        <KatuzeInfo
                            key={item.kod}
                            katuzeItem={item}
                            katuzeInfo={data.katuzeInfo}
                        />
                    )
                })}
            </Stack.Item>
        </Stack>
    );
}

export default IsknDataSetKatuzeInfo;
